"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get CreateActionItemRequest () {
        return CreateActionItemRequest;
    },
    get CreateAgendaItemRequest () {
        return CreateAgendaItemRequest;
    },
    get CreateMeetingParams () {
        return CreateMeetingParams;
    },
    get CreateMeetingRequest () {
        return CreateMeetingRequest;
    },
    get CreateMeetingWorkspaceRequest () {
        return CreateMeetingWorkspaceRequest;
    },
    get ExportCompanyMeetingsRequest () {
        return ExportCompanyMeetingsRequest;
    },
    get ExportWorkspaceMeetingsRequest () {
        return ExportWorkspaceMeetingsRequest;
    },
    get GetActionItemsParams () {
        return GetActionItemsParams;
    },
    get GetAgendaItemsParams () {
        return GetAgendaItemsParams;
    },
    get GetCarryOverItemsParams () {
        return GetCarryOverItemsParams;
    },
    get GetCarryOverItemsQueryString () {
        return GetCarryOverItemsQueryString;
    },
    get GetMeetingDetailsParams () {
        return GetMeetingDetailsParams;
    },
    get GetMeetingNotesParams () {
        return GetMeetingNotesParams;
    },
    get GetMeetingNotesQuery () {
        return GetMeetingNotesQuery;
    },
    get GetMeetingTranscriptParams () {
        return GetMeetingTranscriptParams;
    },
    get GetMeetingsParams () {
        return GetMeetingsParams;
    },
    get GetUpcomingMeetingsQueryString () {
        return GetUpcomingMeetingsQueryString;
    },
    get GetWorkspaceParams () {
        return GetWorkspaceParams;
    },
    get UpdateActionItemParams () {
        return UpdateActionItemParams;
    },
    get UpdateActionItemRequest () {
        return UpdateActionItemRequest;
    },
    get UpdateAgendaItemParams () {
        return UpdateAgendaItemParams;
    },
    get UpdateAgendaItemRequest () {
        return UpdateAgendaItemRequest;
    },
    get UpdateMeetingNoteParams () {
        return UpdateMeetingNoteParams;
    },
    get UpdateMeetingNoteRequest () {
        return UpdateMeetingNoteRequest;
    },
    get UpdateMeetingParams () {
        return UpdateMeetingParams;
    },
    get UpdateMeetingRequest () {
        return UpdateMeetingRequest;
    },
    get UpdateMeetingTranscriptParams () {
        return UpdateMeetingTranscriptParams;
    },
    get UpdateMeetingTranscriptRequest () {
        return UpdateMeetingTranscriptRequest;
    },
    get UpdateMeetingWorkspaceParams () {
        return UpdateMeetingWorkspaceParams;
    },
    get UpdateMeetingWorkspaceRequest () {
        return UpdateMeetingWorkspaceRequest;
    }
});
const _zod = require("zod");
const _models = require("@performyard/models");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const _actionitem = require("./action-item");
const _agendaitem = require("./agenda-item");
const _meeting = require("./meeting");
const _notes = require("./notes");
const _transcript = require("./transcript");
const _workspace = require("./workspace");
const GetWorkspaceParams = _zod.z.object({
    workspaceId: _utilsisomorphic.transformObjectId
});
const CreateMeetingWorkspaceRequest = _workspace.WorkspaceModel.pick({
    name: true,
    participants: true
});
const UpdateMeetingWorkspaceRequest = _workspace.WorkspaceModel.pick({
    name: true,
    status: true,
    participants: true
}).partial();
const UpdateMeetingWorkspaceParams = _zod.z.object({
    workspaceId: _utilsisomorphic.transformObjectId
});
const GetMeetingsParams = _zod.z.object({
    workspaceId: _utilsisomorphic.transformObjectId
});
const GetMeetingDetailsParams = _zod.z.object({
    meetingId: _utilsisomorphic.transformObjectId
});
const GetCarryOverItemsParams = _zod.z.object({
    workspaceId: _utilsisomorphic.transformObjectId
});
const GetCarryOverItemsQueryString = _zod.z.object({
    startDateTime: _utilsisomorphic.transformDate
});
const CreateMeetingRequest = _meeting.MeetingModel.pick({
    name: true,
    description: true,
    startDateTime: true,
    endDateTime: true,
    participants: true
}).extend({
    carryOver: _zod.z.boolean().optional(),
    addToCalendar: _zod.z.boolean().optional()
});
const CreateMeetingParams = _zod.z.object({
    workspaceId: _utilsisomorphic.transformObjectId
});
const UpdateMeetingRequest = _meeting.MeetingModel.pick({
    name: true,
    description: true,
    status: true,
    startDateTime: true,
    endDateTime: true,
    calendarEvent: true
}).extend({
    addToCalendar: _zod.z.boolean().optional(),
    removeFromCalendar: _zod.z.boolean().optional()
}).partial();
const UpdateMeetingParams = _zod.z.object({
    meetingId: _utilsisomorphic.transformObjectId
});
const CreateAgendaItemRequest = _agendaitem.AgendaItemModel.pick({
    name: true,
    meetings: true,
    goalId: true
});
const UpdateAgendaItemRequest = _agendaitem.AgendaItemModel.pick({
    name: true,
    meetings: true,
    goalId: true
}).partial();
const UpdateAgendaItemParams = _zod.z.object({
    agendaItemId: _utilsisomorphic.transformObjectId
});
const GetAgendaItemsParams = _zod.z.object({
    meetingId: _utilsisomorphic.transformObjectId
});
const CreateActionItemRequest = _actionitem.ActionItemModel.pick({
    name: true,
    meetings: true,
    participants: true,
    dueDate: true
});
const UpdateActionItemRequest = _actionitem.ActionItemModel.pick({
    name: true,
    meetings: true,
    participants: true,
    dueDate: true
}).partial();
const UpdateActionItemParams = _zod.z.object({
    actionItemId: _utilsisomorphic.transformObjectId
});
const GetActionItemsParams = _zod.z.object({
    meetingId: _utilsisomorphic.transformObjectId
});
const GetMeetingNotesParams = _zod.z.object({
    meetingId: _utilsisomorphic.transformObjectId
});
const GetMeetingNotesQuery = _zod.z.object({
    visibility: _zod.z.optional(_models.MeetingNoteVisibilitySchema)
});
const UpdateMeetingNoteRequest = _notes.MeetingNoteModel.pick({
    content: true
});
const UpdateMeetingNoteParams = _zod.z.object({
    noteId: _utilsisomorphic.transformObjectId
});
const GetMeetingTranscriptParams = _zod.z.object({
    meetingId: _utilsisomorphic.transformObjectId
});
const UpdateMeetingTranscriptRequest = _transcript.MeetingTranscriptModel.pick({
    content: true
});
const UpdateMeetingTranscriptParams = _zod.z.object({
    meetingId: _utilsisomorphic.transformObjectId
});
const ExportCompanyMeetingsRequest = _zod.z.object({
    filters: _zod.z.record(_zod.z.string(), _zod.z.any()).optional(),
    sort: _zod.z.object({
        name: _zod.z.string(),
        direction: _zod.z.enum([
            "asc",
            "desc"
        ])
    }).optional(),
    timezone: _zod.z.string()
});
const ExportWorkspaceMeetingsRequest = _zod.z.object({
    filters: _zod.z.record(_zod.z.string(), _zod.z.any()).optional(),
    timezone: _zod.z.string()
});
const GetUpcomingMeetingsQueryString = _zod.z.object({
    startDate: _utilsisomorphic.transformDate,
    endDate: _utilsisomorphic.transformDate
});
